// Renders coded context variables (billableCodesICD10 / cpt2codes / friends) as
// "<code> - <description>" bullets for EHR field pastes ({{...}} substitution in
// useEHR's lucasIntegrationGetContent).
//
// The backend "Note - Hub" / "AI Update Note" processes emit billableCodesICD10
// as an array of scored objects: {code, description, evidence, specificity,
// alternatives}. The generic lucasFormatVariable formatter caps nesting at one
// level, so objects below the top level degrade to bare key names — the pasted
// note showed "code, evidence, specificity, description, alternatives" bullets
// instead of the actual codes. This helper special-cases the coded-list shape;
// every other shape returns null so callers fall through to the generic
// formatter unchanged (the dictionary shape keyed by "<code> - <description>"
// already renders its keys correctly there).

import { isNonBillableList, notBilledSuffix } from "./notBilled";

const isCodedItem = (item) =>
  item != null && typeof item === "object" && !Array.isArray(item) && typeof item.code === "string" && item.code.trim() !== "";

// HTML for a coded list, or null when `value` is not an array of coded objects.
// Alternatives are intentionally excluded — only the billed top-level codes
// belong in the note. `variable` is the context-variable name: only the
// Non-Billable Injection section's rows get the "(… not billed)" suffix; a
// flagged row in a regular CPT list pastes plain, matching the note view.
export function formatCodedListHtml(value, variable) {
  if (!Array.isArray(value) || value.length === 0) return null;
  if (!value.every(isCodedItem)) return null;

  const suffix = isNonBillableList(variable) ? notBilledSuffix : () => "";
  const items = value.map((item) => {
    const code = item.code.trim();
    const description = typeof item.description === "string" ? item.description.trim() : "";
    return "<li>" + (description ? code + " - " + description : code) + suffix(item) + "</li>";
  });
  return "<ul>" + items.join("") + "</ul>";
}
